module.exports = __webpack_public_path__ + "img/ic_long-back-arrow.cae63db.svg";